module.exports = __webpack_public_path__ + "img/image_case_4.52e0df6f.png";